import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleRight } from "@fortawesome/pro-light-svg-icons";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const InvestmentCardLeft = (props) => {
  const { data, addInvestment } = props;

  return (
    <div className="investment-card-add">
      <div className="d-flex flex-row justify-content-between investment-card-add-top ">
        <div>{data.cusip}</div>
        <div className="small-text d-flex flex-row">
          <p
            className="link primary-small"
            onClick={() => addInvestment(data.investmentId)}
            style={{
              fontSize: "12px",
              fontWeight: "400",
              marginRight: "5px",
              cursor: "pointer",
              marginBottom: "0px",
            }}
          >
            Click to add
          </p>
          <FontAwesomeIcon
            className="primary-small"
            icon={faAngleDoubleRight}
            style={{
              fontSize: "12px",
              fontWeight: "400",
              paddingTop: "3px",
            }}
          />
        </div>
      </div>
      <div className="investment-card-add-bottom ft-16 fw-600">{data.name}</div>
    </div>
  );
};
export default InvestmentCardLeft;
